// extracted by mini-css-extract-plugin
module.exports = {"container":"rating_container__7pPAd"};